module.exports = __webpack_public_path__ + "static/img/ico-forest.ef47aa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-forest.svg
// module id = Qhl/
// module chunks = 1